import { render, staticRenderFns } from "./JobPostedCardCustomer.htm?vue&type=template&id=df7f67ce&scoped=true&"
import script from "./JobPostedCardCustomer.ts?vue&type=script&lang=js&"
export * from "./JobPostedCardCustomer.ts?vue&type=script&lang=js&"
import style0 from "./JobPostedCardCustomer.scss?vue&type=style&index=0&id=df7f67ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df7f67ce",
  null
  
)

export default component.exports